import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import {
	fireMsrCjnEligibilityChecked,
	getCustomExperimentAnalytics,
} from '../../services/analytics';
import type { EventCacheKey, EventCacheValue } from '../../services/caching';
import { cjnEventCacheController } from '../../services/caching';

export const useFireOnlyNewEvent = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const customAnalytics = getCustomExperimentAnalytics('crossJoinNudges', createAnalyticsEvent);

	/**
	 * Fire event only in case the event value has not been cached or cached value is different
	 * to prevent excessive number of analytics calls.
	 */
	return useCallback(
		({ value, key }: { value: EventCacheValue; key: EventCacheKey | string }) => {
			try {
				const cachedValue = cjnEventCacheController.get(key);
				if (
					!cachedValue ||
					cachedValue.isEligible !== value.isEligible ||
					cachedValue.reason !== value.reason
				) {
					fireMsrCjnEligibilityChecked(customAnalytics, {
						...value,
						key,
					});
					cjnEventCacheController.set(key, value);
				}
			} catch (e) {
				// cache get fail, do nothing
			}
		},
		[customAnalytics],
	);
};
